module.exports = __webpack_public_path__ + "img/83ne.7fdefdfb.svg";